import { Brand as e, Brands as t } from "./Brand.es.js";
const n = {
  [e.TWITTER]: t.twitter,
  [e.LINKEDIN]: t.linkedin,
  [e.INSTAGRAM]: t.instagram,
  [e.FACEBOOK]: t.facebook,
  [e.YOUTUBE]: t.youtube,
  [e.TIKTOK]: t.tiktok,
  [e.REDDIT]: t.reddit,
  email: { name: "email", color: "#DDDDDD", secondaryColor: "#1E2431" },
  website: { name: "website", color: "#DDDDDD", secondaryColor: "#1E2431" }
}, r = Object.keys(n), i = {
  [e.FACEBOOK]: ({ url: o = "" } = {}) => `//www.facebook.com/sharer.php?u=${encodeURIComponent(o)}`,
  [e.LINKEDIN]: ({ url: o = "" } = {}) => `//www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(o)}`,
  [e.WHATSAPP]: ({ text: o = "" } = {}) => `//wa.me/?text=${encodeURIComponent(o)}`,
  [e.TWITTER]: ({ text: o = "" } = {}) => `//twitter.com/intent/tweet?text=${encodeURIComponent(o)}&hashtags=waitroom`
};
export {
  i as Share,
  r as SocialKeys,
  n as Socials
};
